import { render, staticRenderFns } from "./Licitacoes.vue?vue&type=template&id=95fe472a&scoped=true&"
import script from "./licitacoes.ts?vue&type=script&lang=ts&"
export * from "./licitacoes.ts?vue&type=script&lang=ts&"
import style0 from "./Licitacoes.vue?vue&type=style&index=0&id=95fe472a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fe472a",
  null
  
)

export default component.exports